module.exports = __webpack_public_path__ + "res/28-img_game_bg_q_b.302bff025db0514c0d098d5a1250f677.png";